import { Box, Button, Grid2 as Grid, IconButton, LinearProgress, Paper, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { AppContext } from "../../App";
import { usePrevious } from "../../components/CustomHooks";
import useApi, { WEB_SOCKET_TOPIC_CARRILES } from "../../api";
import TableLoader from "../../components/TableLoader";
import EmptyStateLabel from "../../components/EmptyStateLabel";
import { DataGrid } from "@mui/x-data-grid";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { GRID_DEFAULT_PAGINATION_MODEL } from "../../components/DataGrid";
import normalizeFiltros from "../../components/app/Filtros";
import Icon from "@mdi/react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { cambiarEstatusCarril, cambiarSentidoCarril, consultarCarril, consultarCarriles, consultarRegistrosCarril } from "../../api/controlador";
import { formatDateInYear, formatTag } from "../../components/Formatter";
import ComboSelect from "../../components/ComboSelect";
import { toComboValuesRenderer } from "../../components/Utils";
import { isObject, isUndefined, omit } from "lodash";
import { COMBO_CARRIL_RENDER } from "./ListadoCarriles";
import DataLabel from "../../components/DataLabel";
import { green, grey, red } from "@mui/material/colors";
import { mdiSwapHorizontal } from '@mdi/js';
import Panel from "../../components/Panel";
import DialogOkCancel from "../../components/DialogOkCancel";
import LoadingDialog from "../../components/LoadingDialog";
import { useStompClient } from "react-stomp-hooks";
import { isJSON } from "validator";

const defaultFiltros = {
    //estacionamientoId: '',
    query: '',
}

export default function ListadoRegistrosCarril({ ...props }) {
    const { reload } = props;
    const navigate = useNavigate();
    const { notificar } = useContext(AppContext);

    const { carrilId } = useParams();

    const [filtros, setFiltros] = useState({
        ...defaultFiltros,
        carrilId: carrilId,
    });

    const [confirmDialog, setConfirmDialog] = useState({ open: false, msg: null });

    const [paginationModel, setPaginationModel] = useState(GRID_DEFAULT_PAGINATION_MODEL);
    const prevDataPM = usePrevious(paginationModel);
    //const prevQuery = usePrevious(filtros.query);

    const [rowCount, setRowCount] = useState(0);

    const [registros, setRegistros] = useState(null);
    const [carriles, setCarriles] = useState(null);
    const [carril, setCarril] = useState(null);

    const [{ data: registrosData, loading: loadingUsuarios }, registrosApi] = useApi();
    const [{ data: carrilData, loading: loadingCarril }, carrilApi] = useApi();
    const [{ data: carrilesData, loading: loadingCarriles }, carrilesApi] = useApi();

    const [{ data: cambiarEstatusData, loading: loadingCambiarEstatus }, cambiarEstatusApi] = useApi();
    const [{ data: cambiarSentidoData, loading: loadingCambiarSentido }, cambiarSentidoApi] = useApi();

    const [carrilSuscripcion, setCarrilSuscripcion] = useState(null);
    const [carrilRegistrosSuscripcion, setCarrilRegistrosSuscripcion] = useState(null);

    const carrilSuscripcionRef = useRef(carrilSuscripcion);
    const carrilRegistrosSuscripcionRef = useRef(carrilRegistrosSuscripcion);

    const stompClient = useStompClient();

    useEffect(() => {
        if (filtros.carrilId, stompClient) {
            subscribeCarril();
            subscribeRegistrosDelCarril();
        }
    }, [filtros.carrilId, stompClient]);

    useEffect(() => {
        carrilSuscripcionRef.current = carrilSuscripcion;
    }, [carrilSuscripcion]);

    useEffect(() => {
        carrilRegistrosSuscripcionRef.current = carrilRegistrosSuscripcion;
    }, [carrilRegistrosSuscripcion]);

    const subscribeCarril = () => {
        if (carrilSuscripcion) {
            console.log('Cerrando suscripción al websocket para el carril');
            carrilSuscripcion.unsubscribe();
        }
        if (stompClient) {
            console.log('Suscribiendo al websocket para el carril', `${WEB_SOCKET_TOPIC_CARRILES}/${filtros.carrilId}`);
            const _carrilSuscripcion = stompClient.subscribe(`${WEB_SOCKET_TOPIC_CARRILES}/${filtros.carrilId}`, (message) => {
                console.log('Mensaje desde el websocket para los registros del carril', message);
                if (isJSON(message.body)) {
                    const messageData = JSON.parse(message.body);
                    if (messageData && isObject(messageData)) {
                        setCarril(messageData);
                    }
                }
            });
            setCarrilSuscripcion(_carrilSuscripcion);
            console.log('Suscrito al carril', _carrilSuscripcion);
        } else {
            console.warn('No se pudo suscribir al websocket para el carril');
        }
    }

    const subscribeRegistrosDelCarril = () => {
        if (carrilRegistrosSuscripcion) {
            console.log('Cerrando suscripción al websocket para los registros del carril');
            carrilRegistrosSuscripcion.unsubscribe();
        }
        if (stompClient) {
            console.log('Suscribiendo al websocket para los registros del carril', `${WEB_SOCKET_TOPIC_CARRILES}/${filtros.carrilId}/registros`);
            const _carrilRegistrosSuscripcion = stompClient.subscribe(`${WEB_SOCKET_TOPIC_CARRILES}/${filtros.carrilId}/registros`, (message) => {
                console.log('Mensaje desde el websocket para los registros del carril', message);
                if (isJSON(message.body)) {
                    const messageData = JSON.parse(message.body);
                    if (messageData && isObject(messageData)) {
                        setRowCount(messageData.page.totalElements);
                        setRegistros(messageData.content || [])
                    }
                }
            });
            setCarrilRegistrosSuscripcion(_carrilRegistrosSuscripcion);
            console.log('Suscrito a los registros del carril ', _carrilRegistrosSuscripcion);
        } else {
            console.warn('No se pudo suscribir al websocket para los registros del carril');
        }
    }

    useEffect(() => {
        return () => {
            console.log('Cerrando suscripciones al websocket [unmount]');
            if (carrilSuscripcionRef.current) {
                console.log('Cerrando suscripción al websocket para el carril [unmount]');
                carrilSuscripcionRef.current.unsubscribe();
            }
            if (carrilRegistrosSuscripcionRef.current) {
                console.log('Cerrando suscripción al websocket para los registros del carril [unmount]');
                carrilRegistrosSuscripcionRef.current.unsubscribe();
            }
        }
    }, []);

    useEffect(() => {
        if (carrilId) {
            carrilApi(consultarCarril(filtros.carrilId));
            carrilesApi(consultarCarriles());
        }
    }, [carrilId]);

    useEffect(() => {
        if (filtros.carrilId) {
            carrilApi(consultarCarril(filtros.carrilId));
            realizarConsultaRegistros();
        }
    }, [filtros.carrilId]);

    useEffect(() => {
        if (filtros.carrilId && carriles && carriles.length > 0) {
            setCarril(carriles.find(c => c.id === parseInt(filtros.carrilId)));
        }
    }, [filtros.carrilId, carriles]);


    useEffect(() => {
        if (reload) {
            realizarConsultaRegistros();
        }
    }, [reload]);

    useEffect(() => {
        if (registrosData) {
            setRowCount(registrosData.page.totalElements);
            setRegistros(registrosData.content || [])
        }
    }, [registrosData]);

    useEffect(() => {
        if (carrilData) {
            setCarril(carrilData);
        }
    }, [carrilData])

    useEffect(() => {
        if (carrilesData) {
            setCarriles(carrilesData);
        }
    }, [carrilesData])

    useEffect(() => {
        if (!isUndefined(cambiarEstatusData)) {
            notificar("Se ha cambiado el estatus del carril");
            //Se quita por el websocket
            //realizarConsultaRegistros();
        }
    }, [cambiarEstatusData])

    useEffect(() => {
        if (!isUndefined(cambiarSentidoData)) {
            notificar("Se ha cambiado el sentido del carril");
            //Se quita por el websocket
            //realizarConsultaRegistros();
        }
    }, [cambiarSentidoData])

    useEffect(() => {
        if (prevDataPM && (paginationModel.page !== prevDataPM.page || paginationModel.pageSize !== prevDataPM.pageSize)) {
            realizarConsultaRegistros();
        }
    }, [paginationModel]);


    const realizarConsultaRegistros = (resetPM = false) => {
        setRegistros(null);
        if (resetPM) {
            setPaginationModel(GRID_DEFAULT_PAGINATION_MODEL);
        }
        registrosApi(consultarRegistrosCarril(filtros.carrilId, normalizeFiltros(omit(filtros, ['carrilId'])), resetPM ? GRID_DEFAULT_PAGINATION_MODEL : paginationModel));
    }

    const renderEstatusCarril = () => {
        if (!carril) return '...';
        switch (carril.estatus) {
            case 'Activo':
                return <><span style={{ color: 'white', backgroundColor: green[600], padding: '2px 4px 2px 4px' }}>Activo</span></>;
            case 'Inactivo':
                return <><span style={{ color: 'white', backgroundColor: red[500], padding: '2px 4px 2px 4px' }}>Inactivo</span></>;
            case 'Apagado':
                return <><span style={{ color: 'white', backgroundColor: red[500], padding: '2px 4px 2px 4px' }}>Apagado</span></>
            default:
                return 'N/D';
        }
        //return carril.activo ? <><span style={{ color: 'white', backgroundColor: green[600], padding: '2px 4px 2px 4px' }}>Activo</span></> : <><span style={{ color: 'white', backgroundColor: red[500], padding: '2px 4px 2px 4px' }}>Inactivo</span></>;
    }

    const renderEstatusButtonCarril = () => {
        if (!carril) return '...';
        switch (carril.estatus) {
            case 'Activo':
                return 'Inactivar';
            case 'Inactivo':
                return 'Activar';
            case 'Apagado':
                return "N/D";
            default:
                return 'N/D';
        }
    }

    const renderEstatusReversibleCarril = () => {
        if (!carril) return '...';
        const colorStatusReversible = carril.reversibleOn ? green[600] : grey[400];
        return <><Tooltip title={carril.reversibleNombre}><Icon path={mdiSwapHorizontal} size={1.1} color={colorStatusReversible} /></Tooltip></>;
    }

    const handleCambiarEstatusCarril = () => {
        setConfirmDialog({
            open: true,
            msg: <>
                ¿Confirmas cambiar el estatus del carril?
            </>,
            onOk: handleConfirmaCambiarEstatus,
            onCancel: handleCancelDialog
        });
    }

    const handleCambiarEstatusReversibleCarril = () => {
        setConfirmDialog({
            open: true,
            msg: <>
                ¿Confirmas cambiar el sentido del carril?
            </>,
            onOk: handleConfirmaCambiarSentido,
            onCancel: handleCancelDialog
        });
    }


    const handleCancelDialog = () => {
        setConfirmDialog({ open: false, msg: null })
    }

    const handleConfirmaCambiarEstatus = () => {
        setConfirmDialog({ open: false, msg: null })
        cambiarEstatusApi(cambiarEstatusCarril(filtros.carrilId, carril.activo ? 'DESACTIVAR' : 'ACTIVAR'));
    }

    const handleConfirmaCambiarSentido = () => {
        setConfirmDialog({ open: false, msg: null })
        cambiarSentidoApi(cambiarSentidoCarril(filtros.carrilId));
    }

    const columns = useMemo(() => [
        {
            field: 'tag', headerName: 'Tag', minWidth: 150, valueGetter: v => formatTag(v)
        },
        {
            field: 'fechaHora', headerName: 'Fecha', minWidth: 130,
            valueGetter: value => formatDateInYear(value, 'MMM D', ' HH:mm', ', YYYY')
        },
        {
            field: 'tipoEvento', headerName: 'Evento', width: 120,
        },
        {
            field: 'tipoEstancia', headerName: 'Tipo', width: 110,
        },
        {
            field: 'descripcion', headerName: 'Descripción', minWidth: 200, flex: 1,
        }
    ], []);

    return (
        <>
            <Outlet />
            <Panel>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                    <IconButton onClick={() => navigate(-1)} color="secondary">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="body1" color="secondary" sx={{ fontWeight: 450 }}>Registros del carril</Typography>
                </Box>
                <ComboSelect
                    fullWidth
                    required
                    label="Carril de entrada"
                    field="carrilId"
                    disabled={carriles && carriles.length === 0}
                    value={filtros.carrilId}
                    onChange={(e) => {
                        setFiltros({ ...filtros, carrilId: e.target.value });
                    }}
                    options={toComboValuesRenderer(carriles, COMBO_CARRIL_RENDER)}
                />
                {loadingCarriles && <LinearProgress />}
                <Box sx={{ p: 1 }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                                <DataLabel label="Estatus" value={renderEstatusCarril()} />
                                {carril && carril.estatus !== 'Apagado' &&
                                    <Button variant="outlined" color="secondary" onClick={handleCambiarEstatusCarril}>{renderEstatusButtonCarril()}</Button>
                                }
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            {carril && carril.reversible &&
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                                    <DataLabel label="Reversible" align="center" value={renderEstatusReversibleCarril()} />
                                    <Button variant="outlined" color="secondary" onClick={handleCambiarEstatusReversibleCarril}>Invertir</Button>
                                </Box>
                            }
                        </Grid>
                    </Grid>
                    {loadingCarril && <LinearProgress />}
                </Box>
            </Panel>
            <Box sx={{ mt: 2 }}>
                {loadingUsuarios &&
                    <TableLoader columns={columns} rowsNum={5} />
                }
                {registros && registros.length === 0 &&
                    <EmptyStateLabel text="No existen registros con esos criterios" />
                }
                {registros && registros.length > 0 &&
                    <Paper elevation={0} sx={{ width: '100%', borderRadius: 6 }}>
                        <DataGrid
                            sx={{ borderRadius: 6 }}
                            autoHeight
                            disableRowSelectionOnClick
                            columns={columns}
                            rows={registros}
                            // rowCount={rowCount}
                            rowCount={-1}
                            loading={loadingUsuarios}
                            pageSizeOptions={[10]}
                            paginationModel={paginationModel}
                            paginationMode="server"
                            onPaginationModelChange={setPaginationModel}
                            onRowClick={(params, event) => {
                                // const url = grupoOperadorIdIn ? `registrosgrupo/${params.row.id}` : `${params.row.id}`;
                                // const estacionamientoId = params.row.estacionamientoId;
                                const prefijo = params.row.tag.prefijo;
                                const numero = params.row.tag.numero;
                                navigate(`/registros/tags/${prefijo}/${numero}`);
                                //notificar('Cliente seleccionado: ' + params.row.nombre);
                            }}
                        />
                    </Paper>
                }
            </Box>
            <DialogOkCancel {...confirmDialog} />
            <LoadingDialog open={loadingCambiarEstatus || loadingCambiarSentido} />
        </>
    );
}